/*
 * @Description: 人才管理接口文件
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-03-11 21:43:05
 * @LastEditors: Monkey
 * @LastEditTime: 2025-08-20 23:54:48
 */

import config from '@/config';
import http from '@/utils/request';

export default {
  info: {
    list: {
      url: `${config.API_URL}/customer/talent/page`,
      name: '获取人才信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    detailList: {
      url: `${config.API_URL}/customer/talent/page/detail`,
      name: '获取人才详情信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },

    },
    find: {
      url: `${config.API_URL}/customer/talent/findById`,
      name: '查询一个人才详情信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/customer/talent/save`,
      name: '添加或修改人才信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    saveList: {
      url: `${config.API_URL}/customer/talent/saveList`,
      name: '添加或修改人才信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },

    }
  },
  label: {
    group: {
      find: {
        url: `${config.API_URL}/customer/talent/label/group/findByFilialeId`,
        name: '获取标签组',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
      findTalentGroup: {
        url: `${config.API_URL}/customer/talent/label/group/findTalentGroup`,
        name: '获取标签组下的标签',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
      save: {
        url: `${config.API_URL}/customer/talent/label/group/save`,
        name: '按照标签组进行保存',
        post: async function (params) {
          return await http.post(this.url, params);
        },
      },
      remove: {
        url: `${config.API_URL}/customer/talent/label/group/remove`,
        name: '按照标签组进行删除',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
    },
    first: {
      remove: {
        url: `${config.API_URL}/customer/talent/label/first/remove`,
        name: '按照一级标签进行删除',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
    },
    second: {
      remove: {
        url: `${config.API_URL}/customer/talent/label/second/remove`,
        name: '按照二级标签进行删除',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
    }
  },
  follow: {
    save: {
      url: `${config.API_URL}/customer/talent/follow/save`,
      name: '添加人才跟进',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    list: {
      url: `${config.API_URL}/customer/talent/follow/list`,
      name: '获取人才跟进列表',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    }
  },
  channel: {
    page: {
      url: `${config.API_URL}/customer/talent/channel/page`,
      name: '获取渠道列表',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    save: {
      url: `${config.API_URL}/customer/talent/channel/save`,
      name: '添加或修改渠道信息',
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    update: {
      url: `${config.API_URL}/customer/talent/channel/update`,
      name: '修改渠道信息',
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    remove: {
      url: `${config.API_URL}/customer/talent/channel/remove`,
      name: '删除渠道信息',
      get: async function (params) {
        return await http.get(this.url, params);
      }
    }
  },

  log: {
    url: `${config.API_URL}/customer/talent/logs/page`,
    name: '获取人才日志信息',
    get: async function (params, config) {
      config = Object.assign({ codeFlag: true }, config)
      return await http.post(this.url, params, config);
    },
  }
}
